const Loyalty = () => import(/* webpackChunkName: "loyalty setting" */ '@/components/settings/loyalty')
export default {
    name: 'settings',
    path: 'settings/loyalty',
    redirect: '/settings/loyalty/index',
    meta: {label: 'settings'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]},
            component: Loyalty,
            props: true
        }
    ]
}
